(function($) {

  'use strict';
  const initExternalLinks = function () {
    $('a[href^=http]:not([rel~="external"])').each(function () {
      if (
        this.href.indexOf(window.location.hostname) === -1 ||
        this.href.indexOf(`.${window.location.hostname}`) !== -1
      ) {
        $(this).attr('rel', 'external');
      }
    });
    $('a[href$=pdf]').each(function () {
      $(this).attr('rel', 'external');
    });
    $('a[href$=png], a[href$=jpg], a[href$=jpeg], a[href$=gif]').each(
      function () {
        $(this).attr('rel', 'external');
      }
    );
  };

  // Find mailto links and open in a new window.
  const initMailtoLinks = function () {
    $('a[href^="mailto:"]').each(function () {
      if (this.href.indexOf('mailto:') === 0) {
        $(this).attr('rel', 'external');
      }
    });
  };

  const initRelAttributes = function () {
    $('a[rel~="external"]:not(a[rel~="noopener"])').attr(
      'rel',
      'external noopener'
    );
    $('a[rel~="noopener"]:not(a[rel~="external"])').attr(
      'rel',
      'external noopener'
    );
  };

  const initTargetBlank = function () {
    $('a[rel~="external"]').attr('target', '_blank');
  }

  const init = function () {
    initExternalLinks();
    initMailtoLinks();
    initRelAttributes();
    initTargetBlank();
    document.body.classList.add('links-init');
  };

  $(function () {
    if ($('.links-init').length === 0) {
      init();
    }
  });

})(jQuery);
